export const SCRIPT_IDS = {
  STORE: 'store',
  MESSAGES: 'messages',
  GRIFFIN: 'griffin',
  NAVIGATION: 'navigation',
}

export const DEFAULT_LOCALE = {
  LANGUAGE: 'en',
  COUNTRY: 'US',
}

export const TEST_OPTIONS_HEADER = 'X-PP-Test-Options'

export const AMOUNT_TYPES = {
  any: 'any',
  at_least: 'at_least',
  exactly: 'exactly',
}

export const GRADIENT_COLORS = {
  blue: 'blue',
  purple: 'purple',
  fuchsia: 'fuchsia',
  red: 'red',
  teal: 'teal',
  gray: 'gray',
  green: 'green',
  sky: 'sky',
  pink: 'pink',
  orange: 'orange',
}

export const DEFAULT_GRADIENT_COLOR = 'teal'

export const DAYS_THRESHOLD = 28

export const COVER_IMAGE_MAX_TOTAL_SIZE = 1600

export const CONTRIBUTIONS_PAGE_SIZE = {
  mobile: 5,
  desktop: 10,
}

export const USR_TXNS_COOKIE_EXPIRY = 15 * 60 * 1000

export const UNDER_REVIEW_ERROR = 'UNDER_REVIEW'

export const STORAGE_EXPIRATION = 1000 * 60 * 30 // 30 mins

export const FUNDING_SOURCES = {
  HOLDING: 'HOLDING',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
}

export const CFS_INTENT = 'MONEYPOOLS'
export const CFS_ELIGIBILITY_URL = '/myaccount/bundle/product-eligibility'
export const BRAZIL_ELIGIBILITY_URL = '/policy/hub/cip'

export const AUTH_STATES = {
  LOGGEDIN: 'LOGGEDIN',
  IDENTIFIED: 'IDENTIFIED',
}

export const ACCOUNT_TYPES = {
  PERSONAL: 'PERSONAL',
  PREMIER: 'PREMIER',
  BUSINESS: 'BUSINESS',
}

export const SUBSCRIPTION_TYPES = {
  WALLET: 'WALLET',
  CASH: 'CASH',
  CASH_PLUS: 'CASH_PLUS',
}

export const EXPERIMENTS = {
  // all experiments created with Elmo, unless otherwise stated
  MONEY_POOLS_MAIN: {
    TREATMENT: 'money_pools_main_treatment',
    CONTROL: 'money_pools_main_control',
  },
  P2P_GUEST_FF: {
    TREATMENT: 'p2p_guest_friends_and_family_treatment',
    CONTROL: 'p2p_guest_friends_and_family_control',
  },
  CFPB: {
    // NOTE: these are from PXP
    TREATMENT: 'cfpb_paypal_cash_us_treatment',
    CONTROL: 'cfpb_paypal_cash_us_control',
  },
}

// We use an experiment to check whether the guest user can do guest F&F
// and we'll check this list of countries to see if the pool owner can receive
// guest contributions. Elmo was not allowing us to spoof the security context in
// prod.
export const guestEnabledCountries = [
  'US',
  'AT',
  'BE',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PL',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
]

/* ------------- */

export const ELMO_RESOURCE_NAME = 'main:walletweb:transfer'

export const PXP_PAGE_NAME = 'cfpb_paypal_cash_us'

// TIP: if you ever need to add more to these, you can do something like below:
// const PXP_PAGE_NAME = [
// 	'cfpb_paypal_cash_us',
// 	'some:other:page',
// ].join(',')

/* ------------- */
